import { render, staticRenderFns } from "./dictionary-form.vue?vue&type=template&id=28c5babc&"
import script from "./dictionary-form.vue?vue&type=script&lang=ts&"
export * from "./dictionary-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports